import i18next from 'i18next'

import { ValidateFormService } from 'services/ValidateFormService'
import { OrderKeys } from 'sections/LKSection/modules/OrderModule/data'
import { PickPointLocation } from 'sections/LKSection/modules/OrderModule/types'
import { validatePickPointFiles } from 'sections/LKSection/shared/PickPointSharedModule/components/PickPointFilesForm/validate'
import {
  COURIER_WAY_MAX,
  PICKPOINT_DESCRIPTION_MAX,
  PICKPOINT_DESCRIPTION_MIN,
} from 'sections/LKSection/shared/PickPointSharedModule/data'

import { ViewPvzUiStore } from '../../../stores/ViewPvz/ViewPvzUiStore'

export class ValidatePvz extends ValidateFormService {
  validate = (uiStore: ViewPvzUiStore) => {
    const errors: string[] = []

    const getLocationKey = (key: string) => `${OrderKeys.locationStep}.validate.${key}`
    const getWorkConditionsKey = (key: string) => `${OrderKeys.workConditionsStep}.validate.${key}`

    if (uiStore.description.trim().length === 0) {
      errors.push(i18next.t(getLocationKey('Поле Как найти ПВЗ')))
    } else {
      if (uiStore.description.trim().length < 30) {
        errors.push(i18next.t(getLocationKey('descriptionMinLength'), { count: PICKPOINT_DESCRIPTION_MIN }))
      }
      if (uiStore.description.length > 200) {
        errors.push(i18next.t(getLocationKey('descriptionMaxLength'), { count: PICKPOINT_DESCRIPTION_MAX }))
      }
    }

    if (uiStore.selectedPvz?.floorLevel === PickPointLocation.shoppingMall && uiStore.courierWay.trim().length === 0) {
      errors.push(i18next.t(getLocationKey('Поле Информация для курьеров')))
    }

    if (uiStore.courierWay.length > 256) {
      errors.push(i18next.t(getLocationKey('courierWayMaxLength'), { count: COURIER_WAY_MAX }))
    }

    if (!uiStore.dressingRoomsCount) {
      errors.push(i18next.t(getWorkConditionsKey('dressingRoomsCountRequired')))
    } else {
      if (+uiStore.dressingRoomsCount < 0) {
        errors.push(i18next.t(getWorkConditionsKey('dressingRoomsCountMin'), { count: 0 }))
      }
    }

    errors.push(...(validatePickPointFiles.validate(uiStore.fileList, 'array', 'activate') as string[]))

    return this.hasNotErrors(errors)
  }
}

export const validatePvz = new ValidatePvz()
